export default {

    start: function (apiFunction, meantime) {

        const pathName = window.location.pathname

        return new Promise((resolve, reject) => {

            loop(apiFunction, meantime, pathName, resolve, reject)

        })

    }

}

function loop(apiFunction, meantime, pathName, resolve, reject) {

    apiFunction()
        .then(data => {

            if (data.done) {

                resolve(data.result)

            } else {

                if (meantime) {

                    meantime(data)

                }

                if (pathName === window.location.pathname) {

                    waiting(apiFunction, meantime, pathName, resolve, reject, data.retry)

                }

            }

        })
        .catch(error => {

            reject(error)

        })

}

function waiting(apiFunction, meantime, pathName, resolve, reject, time) {

    setTimeout(function () {

        loop(apiFunction, meantime, pathName, resolve, reject)

    }, time)
}

